import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
  public date!: string;
  private startYear = 2015;

  ngOnInit() {
    const currentYear: number = new Date().getFullYear();
    this.date = `${this.startYear}–${currentYear}`;
  }
}
